import { forwardRef, type TextareaHTMLAttributes } from "react";

import { cx } from "../lib/format";

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
  /** Mono face — e.g. prompt editing. */
  mono?: boolean;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(function TextArea(
  { invalid = false, mono = false, className, rows = 4, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      aria-invalid={invalid || undefined}
      className={cx(
        "w-full rounded border bg-surface px-3 py-2 text-sm text-bright placeholder:text-muted",
        "resize-y transition-colors focus:outline-none",
        invalid ? "border-danger" : "border-line focus:border-muted",
        "disabled:cursor-not-allowed disabled:opacity-50",
        mono && "font-mono",
        className,
      )}
      {...rest}
    />
  );
});
